import { useState, useRef, useEffect } from 'react';
import { MessageCircle, User, Home, Terminal } from 'lucide-react';
import { useMsal } from '@azure/msal-react';
import { loginRequest,graphConfig, apiRequest } from '../../authentication/authConfig';
import { useBoundingBoxStore } from '../../store/useBoundingBoxStore';
import '../../fonts.css'
import SidePanel from './3Dsidepanel';
import {  useLocation } from "react-router-dom";
import SettingsComponent from './SettingsComponent';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import CloseIcon from '@mui/icons-material/Close';

const sanitizeImageSrc = (value) => {
  if (typeof value !== 'string') {
    return null;
  }

  try {
    const parsed = new URL(value, window.location.origin);
    const isAllowedBlob = parsed.protocol === 'blob:';
    const isAllowedHttp = (parsed.protocol === 'https:' || parsed.protocol === 'http:')
      && parsed.origin === window.location.origin;

    if (isAllowedBlob || isAllowedHttp) {
      return parsed.href;
    }
  } catch {
    // Invalid URL gets treated as unsafe.
  }

  return null;
};

const Header = ({ title = "Title", onHomeClick }) => {
  const { instance, accounts } = useMsal();
  const [profilePicture, setProfilePicture] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const name = accounts[0] && accounts[0].name;
  const [isPanelOpen, setIsPanelOpen] = useState(true);
  const [isVisible, setIsVisible] = useState(true);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [userDept, setUserDept] = useState(null);
  const boundingBoxNE = useBoundingBoxStore(state => state.ne);
  const boundingBoxSW = useBoundingBoxStore(state => state.sw);


  function extractQueryParams(url) {
    try {
      const parsed = new URL(url, window.location.origin);
      if (parsed.origin !== window.location.origin) {
        return '';
      }

      // Keep only short, URL-safe characters to avoid passing untrusted content to mailto.
      const safeQuery = parsed.search
        .slice(1)
        .replace(/[^a-zA-Z0-9=&_\-]/g, '')
        .slice(0, 200);

      return safeQuery ? `(${safeQuery})` : '';
    } catch {
      return '';
    }
  }
  const getCurrentShareLink = () => {
   
    let linkToShare = window.location.href;
    if (linkToShare.includes("3d-view")) {
      const stored = sessionStorage.getItem("ShareURL");
      if (stored) {
        try {
          const parsed = new URL(stored, window.location.origin);
          if (parsed.origin === window.location.origin) {
            linkToShare = parsed.href;
          }
        } catch {
          // invalid URL — keep the current href
        }
      }
    }
    return linkToShare;
  };
  const handleSupportClick = () => {
  const link = getCurrentShareLink();
    const subject = `BausGIS | Support Request |${extractQueryParams(link)}`;
    const body = `Beschreib das Problem und schick uns einen Screenshot mit.`;
    const mailtoParams = new URLSearchParams({
      subject,
      body,
    });
    const mailtoLink = `mailto:bim-support@goldbeck.de?${mailtoParams.toString()}`;
    window.open(mailtoLink, '_self', 'noopener,noreferrer');
  };
  const shouldShowPanel = (url) => {
  return url.includes('/3d-view');
};

  const location = useLocation();

  useEffect(() => {
    if (shouldShowPanel(location.pathname)) {
      setIsVisible(true);
      setIsPanelOpen(true);
   
    }
    else{setIsVisible(false),closePanel()}
  }, [location.pathname]);
  
 
  const togglePanel = () => {
    setIsPanelOpen(!isPanelOpen);
  };

  const closePanel = () => {
  setIsPanelOpen(false);
};

  useEffect(() => {
    // Fetch user profile picture
    const getProfilePicture = async () => {
      setIsLoading(true);
      
      try 
      {
        const account = accounts[0];
        if (account) 
        {
          const response = await instance.acquireTokenSilent({
            ...loginRequest,
            account: account
          });
          const headers = new Headers();
          headers.append("Authorization", `Bearer ${response.accessToken}`);
       

          // Try to get profile photo
          const photoResponse = await fetch(
            "https://graph.microsoft.com/v1.0/me/photo/$value", 
            { method: "GET", headers }
          );
          
          if (photoResponse.ok) {
            const photoBlob = await photoResponse.blob();
            const photoUrl = URL.createObjectURL(photoBlob);
            if (photoUrl.startsWith('blob:')) {
              setProfilePicture(photoUrl);
            }
          }
           // Get profile metadata
          const userResponse = await fetch(
            "https://graph.microsoft.com/v1.0/me",
            { method: "GET", headers }
          );
          // Get dept
          const deptresponse = await fetch('https://graph.microsoft.com/v1.0/me?$select=department', 
                { method: "GET", headers }
          );
          const deptData = await deptresponse.json();
         


        if (userResponse.ok && deptresponse.ok) {
            const userData = await userResponse.json();
            setUserInfo({
              displayName: userData.displayName,
              jobTitle: userData.jobTitle,
              department: deptData.department,
              officeLocation: userData.officeLocation,
              mail: userData.mail,
              givenName: userData.givenName
            });
        }
      } 
    }
      catch (error) {
        console.error("Error fetching profile picture:", error);
      } finally {
        setIsLoading(false);
      }
    };
    
    if (accounts.length > 0) {
      getProfilePicture();
    }
    
    // Clean up the object URL when component unmounts
    return () => {
      if (profilePicture) {
        URL.revokeObjectURL(profilePicture);
      }
    };
  }, [accounts, instance]);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const safeProfilePicture = sanitizeImageSrc(profilePicture);
  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: "/login",
    });
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const divStyle = {
    position: 'absolute',
    left: `40px`,
    top: `2px`,
    width:"60px",
    height:"60px"

   
  };

  
 
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <header 
      style={{ 
        backgroundColor: 'white', 
        padding: '0 20px',
        height:"60px",
        display: 'flex',
        position: 'relative',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
        zIndex:10

      }}
    > 
    {/* Logo on the left */}
    <div className="rounded-md bg-green-800 border border-gray-300 overflow-hidden"
      style={{
        width: '40px',           
        height: '40px',       
        marginLeft:"105px",
        marginTop:"4.53px"
      }}>
      <img src="\assets\LageplanDesignerLogo.svg" alt="LageplanDesignerLogo" className="w-full h-full object-cover" />
    </div>
     {/* Title */}
    <div>
        <h1 
        style={{ 
          color: '#1a202c', 
          fontWeight: '1000',
          fontSize: '21px',
          position: 'absolute',
          left: '280px',
          top:"20px",
          transform: 'translateX(-50%)',
          margin: 0,
          fontFamily:"GoldbeckNextSemiBold2",
          marginLeft:-65
        }}
      >
        {title}
      </h1>
    </div>

    {/* Side panel toggle button */}
    <button 
        aria-label="SidePanel"
        onClick={togglePanel}
        disabled={!isVisible}
        style={{ 
          position:"absolute",
          border:"none",
          boxShadow:"none",
          backgroundColor: 'white',
          outline:"none",
          padding: '1rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          zIndex: 10,
          left:"56px",
          top:"14px",
          height:"40px",
          width:"40px",
          borderRadius: '9999px',
    
                 
        }}
         onMouseOver={(e) => {e.currentTarget.style.backgroundColor = '#EEEFF0'; e.currentTarget.style.color = '#FFFFFF';}}
         onMouseOut={(e) => {e.currentTarget.style.backgroundColor = 'white'; e.currentTarget.style.color = '#FFFFFF';}}
      >
         {/* Image inside the button */}
       {!isPanelOpen ? (
          <img 
            src="\assets\SidePannelButton.svg" 
            alt="Home" 
            style={{ width: '20px', height: '20px' }} 
          />
        ) : (
          <CloseIcon style={{ width: '20px', height: '20px', color:"black" }} />
        )}
      </button>
      <SidePanel isOpen={isPanelOpen} onClose={closePanel} />
      
      {/* Right-aligned buttons */}
      <div style={{ 
        marginLeft: 'auto', 
        display: 'flex', 
        alignItems: 'center',
        gap: '1rem',
        position: 'relative',
        zIndex: 10
      }}>
        {/* Feedback button */}
        <button 
        onClick={handleSupportClick}
          aria-label="Feedback"
          style={{ 
            color: '#4a5568', 
            backgroundColor: 'white',
            padding: '1rem',
            display: 'flex',
            border:"none",
            outline:"none",
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            marginRight:"10px", 
            width:"20px",
            height:"20px"
          }}
          onMouseOver={(e) => {e.currentTarget.style.backgroundColor = '#EEEFF0'; e.currentTarget.style.color = '#1a202c';}}
          onMouseOut={(e) => {e.currentTarget.style.backgroundColor = 'white'; e.currentTarget.style.color = '#4a5568';}}
        >
          <ChatBubbleIcon 
          style={{ width: '20px', height: '20px' ,objectFit:"cover"}} 
        />
        </button>

        
        {/* Profile button with dropdown */}
        <div style={{ position: 'relative' }} ref={dropdownRef}>
          <button 
            onClick={toggleDropdown}
            
            aria-label="User profile"
            aria-expanded={isDropdownOpen}
            aria-controls="profile-dropdown"
            style={{ 
              color: '#4a5568', 
              backgroundColor: 'white',
              zIndex:-1000,
              border: '1px solid #e2e8f0',
              borderRadius: '99999px',
              padding: '0.1rem',
            
              outline:"none",
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              overflow: 'hidden', // Keep the image within the rounded button
              width: '40px',      // Fixed width for consistency
              height: '40px' ,
              marginRight:"60px"
            }}
            onMouseOver={(e) => {e.currentTarget.style.backgroundColor = '#f7fafc'; e.currentTarget.style.color = '#1a202c';}}
            onMouseOut={(e) => {e.currentTarget.style.backgroundColor = 'white'; e.currentTarget.style.color = '#4a5568';}}
          >
               {isLoading ? (
          // Loading state
          <div style={{ width: '20px', height: '20px', borderRadius: '10%', backgroundColor: '#e2e8f0' }}></div>
        ) : safeProfilePicture ? (
          // Profile picture available
          <img 
            src={safeProfilePicture} 
            alt="Profile" 
            style={{ 
              width: '100%', 
              height: '100%', 
              objectFit: 'cover',
              borderRadius: '50%',
              
            }}
          />
        ) : (
          // Fallback to generic icon
          <User size={24} />
        )}
          </button>
          
          {/* Dropdown menu */}
          {isDropdownOpen && (
            <div 
              id="profile-dropdown"
              style={{ 
                position: 'absolute',
                right: 0,
                top: '100%',
                marginTop: '0.5rem',
                width: '12rem',
                backgroundColor: 'white', 
                
                border: '1px solid #e2e8f0',
                borderRadius: '0.375rem',
                zIndex: 50,
                overflow: 'hidden'
              }}
            >
              <div 
                style={{ 
                  padding: '0.75rem 1rem',
                  borderBottom: '1px solid #f7fafc' 
                }}
              >
                <p 
                  style={{ 
                    color: '#1a202c', 
                    fontSize: '0.875rem', 
                    fontWeight: '500',
                    margin: 0,
                    fontFamily:"GoldbeckNextSemiBold2"
                  }}
                >
                  Hallo! {name.split(" ")[1]}
                </p>
              </div>
              <div>
                <button 
                  onClick={() => {setIsSettingsOpen(true)}}
                  style={{ 
                    color: '#4a5568', 
                    backgroundColor: 'white',
                    fontSize: '0.875rem', 
                    textAlign: 'left', 
                    width: '100%',
                    padding: '0.5rem 1rem',
                    display: 'flex',
                    alignItems: 'center',
                    border: 'none',
                    cursor: 'pointer',
                    fontFamily:"GoldbeckNextRegular" ,
                    // border:"none",
                    outline:"none"
                  }}
                  onMouseOver={(e) => {e.currentTarget.style.backgroundColor = '#f7fafc';}}
                  onMouseOut={(e) => {e.currentTarget.style.backgroundColor = 'white';}}
                >
                  <SettingsIcon 
                    style={{ 
                      color: '#718096', 
                      marginRight: '0.75rem', 
                      height: '1.25rem', 
                      width: '1.25rem'  
                    }}
                  />
                
                  Settings
                </button>
                
                <button 
                  style={{ 
                    color: 'black', 
                    backgroundColor: 'white',
                    fontSize: '0.875rem', 
                    textAlign: 'left', 
                    width: '100%',
                    padding: '0.5rem 1rem',
                    display: 'flex',
                    alignItems: 'center',
                    
                    cursor: 'pointer',
                    fontFamily:"GoldbeckNextSemiBold2",
                    border:"none",
                    outline:"none"
                  
                  }}
                  onMouseOver={(e) => {e.currentTarget.style.backgroundColor = '#f7fafc';}}
                  onMouseOut={(e) => {e.currentTarget.style.backgroundColor = 'white';}}
                  onClick={handleLogout} className='logout-button'
                >
                  <LogoutIcon 
                    style={{ 
                      color: 'black', 
                      marginRight: '0.75rem', 
                      height: '1.25rem', 
                      width: '1.25rem' 
                    }}
                   
                  />
                  Log Out
                </button>
                <SettingsComponent 
                      isOpen={isSettingsOpen} 
                      onClose={() => setIsSettingsOpen(false)}
                      userInformation ={userInfo}
                      // userName={name.split(" ")[1]}
                      profilepicture = {safeProfilePicture}
                    />
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};


const ColorResistantHeader = ({ onHomeClick, ...props }) => {

  
  return (
    <div style={{ colorScheme: 'light', width: '100%' }}>
      <Header {...props} onHomeClick={onHomeClick} />
    </div>
  );
};

export default ColorResistantHeader;